<template >
  <v-container>
    <form>
      <v-container>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{$t("notify_rule")}}
                </th>
                <th class="text-left">
                  <v-icon>mdi-email</v-icon>&nbsp;{{$t("email")}}
                </th>
                <th class="text-left">
                  <v-icon>mdi-bell</v-icon>&nbsp;{{$t("push_notify")}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="notify in notifyData"
                :key="notify.tag"
              >
                <td>
                  {{notify.dex}}
                </td>
                <td>
                  <v-switch v-model="notify.ifEmail"></v-switch>
                </td>
                <td>
                  <v-switch v-model="notify.ifNotify"></v-switch>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <v-btn
              min-width="200px"
              @click="saveNotifyRules"
              color="success"
            >{{
              $t("save")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </v-container>
</template>
<script>
import Swal from "sweetalert2";

export default {
  name: "user-edit-auto-notify",
  props: {
    masterId: null,
  },
  components: {},
  data() {
    return {
      notifyData: [],
    };
  },
  methods: {
    loadData() {
      let _ = this;
      this.chiamataAxios(
        "GET",
        "/auth/notify/getUserAutoNotifyRoles/" + _.masterId
      ).then((response) => {
        _.notifyData = response && response.data ? response.data : [];
      });
    },
    saveNotifyRules: function () {
      let _ = this;
      _.chiamataAxios(
        "POST",
        "/auth/notify/setUserAutoNotifyRoles/" + _.masterId,
        {
          body: _.notifyData,
          msg: "always",
          dialogLoader: true,
        }
      );
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
  display: function (value) {
    this.$nextTick(function () {
      this.loadData();
    });
  },
};
</script>

